module.exports = __webpack_public_path__ + "img/zrx.b9cee4a8.svg";